// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2YFEV","fileBtn":"File_fileBtn__3hTh-","closeBtn":"File_closeBtn__1JmUw","fileSelected":"File_fileSelected__1ZjPN","disabled":"File_disabled__3vgCC"};